export type RevenueSign = 'revenue_positive' | 'revenue_negative';

// ── Per-step snapshots ────────────────────────────────────────────────────────
// Each snapshot is a strict slice — a step can only write to its own interface.

export interface ErpStepSnapshot {
    selectedErpId: string | null;
    selectedErpName: string | null;
    defaultSignConvention: RevenueSign | null;
}

export interface ImportFileEntry {
    file: File;
    fileId: string | null;
    sheets: string[];
    selectedYears: number[];
    selectedSheets: string[];
    /** True when the backend recognized this upload as the demo GL file. */
    isDemo: boolean;
}

export interface ImportStepSnapshot {
    fileEntries: ImportFileEntry[];
}

export interface FieldMappingStepSnapshot {
    /** True when every mandatory (header) UDM field has an ERP column mapped. */
    allMandatoryMapped: boolean;
}

export interface ChartOfAccountsStepSnapshot {
    categories: string[];
}

export interface ConnectAiStepSnapshot {
    aiProvider: string | null;
}

export interface RevenueFormatStepSnapshot {
    revenueSign: RevenueSign | null; // null = user skipped
}

// ── Full onboarding state ─────────────────────────────────────────────────────

export interface OnboardingState {
    erp: ErpStepSnapshot;
    import: ImportStepSnapshot;
    fieldMapping: FieldMappingStepSnapshot;
    revenueFormat: RevenueFormatStepSnapshot;
    chartOfAccounts: ChartOfAccountsStepSnapshot;
    connectAi: ConnectAiStepSnapshot;
}

export const INITIAL_ONBOARDING_STATE: OnboardingState = {
    erp: { selectedErpId: null, selectedErpName: null, defaultSignConvention: null },
    import: { fileEntries: [] },
    fieldMapping: { allMandatoryMapped: false },
    revenueFormat: { revenueSign: null },
    chartOfAccounts: { categories: [] },
    connectAi: { aiProvider: null },
};
